import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import birdFood from './../../../images/bird-food.png';
import powercss from './../../../styles/power.css';
import template from './review.html';

@Component({
  controllerAs: 'productReview',
  template
})

export default class ProductReview {
  static $inject = [
    '$rootScope',
    '$scope',
    '$ngRedux',
    '$stateParams',
    '$state',
    'toaster',
    'orderService',
    'spinnerService',
    'orderActions',
    'authService',
    '$window',
    'APP',
    'ngMeta',
    '$location'
  ];

  constructor($rootScope,$scope, $ngRedux, $stateParams, $state, $toaster, $order, $spinner, orderActions, $auth, $window, APP, ngMeta, $location) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.birdFood = birdFood;
    this.$state = $state;
    this.$toaster = $toaster;
    this.$auth = $auth;
    this.$window = $window;
    this.APP = APP;
    this.ngMeta = ngMeta;
    this.$location = $location;
    this.$spinner = $spinner;
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.subCategoryName ='';
    this.categoryName = '';
    this.storeName = '';
    var $ctrl= this;
    console.log("Inside power review document ");
    // if( window.localStorage )
    //   {
    //     if( !localStorage.getItem('first.load.for.write.review') )
    //     {
    //       localStorage['first.load.for.write.review'] = true;
    //       window.location.reload();
    //     }  
    //     else {
    //       localStorage.removeItem('first.load.for.write.review');
    //     } 
    //   }

    setTimeout(() => {
      console.log("Waiting for 2 secs before loading power reviews to write a review");
    }, 1000);
    
    window.pwr = window.pwr || function () {
        (window.pwr.q = window.pwr.q || []).push(arguments); 
       };
       setTimeout(() => {
        window.pwr("render", {
          api_key: this.APP.AUTH.AUTH_URL.pwr.api_key,
          locale: this.APP.AUTH.AUTH_URL.pwr.locale,
          merchant_group_id: this.APP.AUTH.AUTH_URL.pwr.merchant_group_id,
          merchant_id: this.APP.AUTH.AUTH_URL.pwr.merchant_id,
          style_sheet: powercss,
          on_render : function(config, data) {
            if(config!=null){
              if(!$ctrl.isNotMobile()){
                var questionform = document.getElementsByClassName("pr-question-form");
                if(questionform.length>0){
                  questionform[0].style.padding='15px';
                }
                var reviewform = document.getElementsByClassName("pr-war"); 
                if(reviewform.length>0){
                  reviewform[0].style.padding='15px';
                }
              }
            }
          },
          on_submit:function(config, data){
              window.scrollTo(0,0);
              },
          components: {
          Write: 'pr-write'
          }
        });
      }, 1000);
  }

  mapState(state) {
    return {
    };
  }

  isNotMobile() {
    return (this.$window.innerWidth > 767);
  }
}


// WEBPACK FOOTER //
// ./src/app/order/product/review.js